<template>
  <div class="px-10 pt-10 pb-2">
    <h1 class="mb-5">{{ props.title }}</h1>
    <p class="text-gray-400" v-if="props.description">{{ props.description }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  description?: string;
}

const props = defineProps<Props>();
</script>

<style scoped></style>
